// extracted by mini-css-extract-plugin
module.exports = {"collapsed":"sidebar_collapsed__B4Ga7"};